import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface LeaseLiabilityInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function LeaseLiabilityInternalControls({ onBack, setActiveSection, controlsListSection }: LeaseLiabilityInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Lease Liability - Ind AS"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
